import { createSlice } from '@reduxjs/toolkit'

const buttonSlice = createSlice({
  name: 'buttonSlice',
  initialState: {
    refreshClicked: false,
    createData: false,
    editData: false,
    deleteData: false,
    saveCheck: false,
    activeStep: 0,
    showClicked: false,
    refreshButtonList: false,
    nextClicked: false
  },
  reducers: {
    onRefreshButton: (state) => {
      state.refreshClicked = true
    },
    offRefreshButton: (state) => {
      state.refreshClicked = false
    },
    createPrivileges: (state) => {
      state.createData = true
    },
    editPrivileges: (state) => {
      state.editData = true
    },
    deletePrivileges: (state) => {
      state.deleteData = true
    },
    setSaveCheck: (state, action) => {
      state.saveCheck = action.payload
    },
    backStep: (state) => {
      state.activeStep -= 1
    },
    nextStep: (state) => {
      state.activeStep += 1
    },
    setStep: (state, action) => {
      state.activeStep = action.payload
    },
    showButton: (state) => {
      state.showClicked = !state.showClicked
    },
    updateRefreshButtonList: (state) => {
      state.refreshButtonList = !state.refreshButtonList
    },
    onNextButton: (state) => {
      state.nextClicked = true
    },
    offNextButton: (state) => {
      state.nextClicked = false
    },
  },
})

export const {
  onNextButton,
  offNextButton,
  onRefreshButton,
  offRefreshButton,
  createPrivileges,
  editPrivileges,
  deletePrivileges,
  setSaveCheck,
  backStep,
  nextStep,
  setStep,
  showButton,
  updateRefreshButtonList,
} = buttonSlice.actions

export const buttonReducer = buttonSlice.reducer